// This file will handle the API calls to purchase courses or other things through Mollie

// To only be in effect if user is on the purchase page

if (window.location.href.match("lifetime-access")) {
    const purchaseButtons = document.querySelectorAll('[purchase-functionality]')

    for (let i = 0; i < purchaseButtons.length; i++) {
        purchaseButtons[i].addEventListener("click", () => {
            this.purchaseItem(["ALL_COURSES"])
        })
    }

    const path = document.querySelector('[purchase-functionality]')?.getAttribute('path')

    // This function calls the api that will return a mollie link for payment
    purchaseItem = async (itemsToBePurchased = String) => {

        const progressJson = localStorage.getProgressJson();
        if (progressJson === null || progressJson === undefined) {
            window.location.href = "/login";
            return;
        }

        var productCodes = [];

        // For new items like study tracks, make sure to add a new condition to this if statement
        // with the name of the group as is in collow for productCodes. 
        for (var i = 0; i < itemsToBePurchased.length; i++) {
            if (itemsToBePurchased[i] === 'ALL_COURSES') {
                product_name = "ALL_COURSES"
                productCodes[i] = "$_ALL COURSES"
            }
        }

        const bodyOfRequest = {
            "items": [
                {
                    "product_name": `${product_name}`,
                    "quantity": itemsToBePurchased.length,
                    "product_description": productCodes
                }
            ]
        }

        try {
            const response = await fetch(path + "/payment/pay", {
                method: "post",
                headers: {
                    Authorization: window.localStorage.getItem("token"),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(bodyOfRequest),
            });
            const mollieUrl = await response.json()
            window.location.replace(mollieUrl);
        } catch (e) {
            console.error('The following error has occured' + e)
        }
    }
} else if (window.location.href.match("assessment")) {
    const purchaseButtons = document.querySelectorAll('[purchase-functionality]')

    for (var i = 0; i < purchaseButtons.length; i++) {
        const JBDFBASDGAOGAG = purchaseButtons[i].getAttribute('texterror')
        purchaseButtons[i].addEventListener("click", () => {
            this.purchaseBFA()      //BFA = Brains First Assessment
        })
    }

    const path = document.querySelector('[purchase-functionality]')?.getAttribute('path')

    purchaseBFA = async () => {
        //Redirect to log in page if user is not logged in
        if (!this.localStorage.progressJson) {
            _collow.Notify.error(document.querySelector('[purchase-functionality]').getAttribute('textError'),
                {
                    actionLabel: document.querySelector('[purchase-functionality]').getAttribute('actionError'),
                    href: this.origin + '/login'
                })
        }
        const userInfo = JSON.parse(this.localStorage.progressJson)

        //Code must work only if the user has a firstname
        if (!userInfo.firstname) {
            _collow.Notify.info(document.querySelector('[purchase-functionality]').getAttribute('textInfo'),
                {
                    actionLabel: document.querySelector('[purchase-functionality]').getAttribute('actionInfo'),
                    href: this.origin + '/profile/settings'
                })
        } else {
            const bodyOfRequest = {
                "items": [
                    {
                        "product_name": `BRAINSFIRST_ASSESSMENT`,
                        "quantity": 1,
                        "product_description": 'BRAINSFIRST ASSESSMENT'
                    }
                ]
            }
            try {
                const response = await fetch(path + "/payment/pay", {
                    method: "post",
                    headers: {
                        Authorization: window.localStorage.getItem("token"),
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(bodyOfRequest),
                });

                if (!response.ok) {
                    error = await response.json()


                    if (error.detail.error_code == "brainsfirst-profile-exists") {
                        _collow.Notify.info(document.querySelector('[purchase-functionality]').getAttribute('toasterSuccess'))

                        return;
                    }
                }
                const mollieUrl = await response.json()
                window.location.replace(mollieUrl);
            } catch (e) {
                console.error('The following error has occured' + e)
            }
        }
    }
}